// ✅ Region detection constants

/**
 * Cache duration for region information
 */
export const REGION_CACHE = {
  /** Cache duration in milliseconds (1 min dev, 6 hours prod) */
  // ✅ FIX: 캐시 만료 시간을 6시간으로 늘려 새로고침 시에도 빠르게 캐시 사용
  DURATION_MS: import.meta.env.DEV ? 60_000 : 6 * 60 * 60 * 1_000,
  /** Interval to check region when tab becomes visible (1 min dev, 30 min prod) */
  VISIBILITY_CHECK_MS: import.meta.env.DEV ? 60_000 : 30 * 60 * 1_000,
} as const;

/**
 * API configuration for region detection
 */
export const REGION_API = {
  /** Region detection API endpoint */
  ENDPOINT: '/api/detect-region',
  /** Request timeout in milliseconds */
  TIMEOUT_MS: 5_000,
  /** Maximum retry attempts on failure */
  RETRY_ATTEMPTS: 3,
  /** Initial delay between retries in milliseconds */
  RETRY_DELAY_MS: 1_000,
} as const;

/**
 * Supported region codes
 */
export const SUPPORTED_REGIONS = {
  KOREA: 'KR',
  USA: 'US',
  JAPAN: 'JP',
  UK: 'GB',
  CHINA: 'CN',
} as const;

export type SupportedRegionCode = (typeof SUPPORTED_REGIONS)[keyof typeof SUPPORTED_REGIONS];

/**
 * Storage keys for region/language persistence
 */
export const REGION_STORAGE_KEYS = {
  CACHE: 'region_cache',
  TEST: 'test_region',
  I18N_LNG: 'i18nextLng',
} as const;
